module.exports = __webpack_public_path__ + "static/card-artisienne-09e21d18438bf28a3a3ba280cefc68af.png";